import React, { useState, useMemo, useEffect } from 'react';
import {
  MetricsSelector,
  NetValueChart,
  TradingFeatures,
  ActionBar
} from './components/OverviewTab';
import { ScrollArea } from '@/components/ui/scroll-area';
import Summary from '@/components/Summary';
import { TotalData, OverviewTabKeyNames } from './index.type';

const OverviewTab: React.FC<{ totalData: Pick<TotalData, OverviewTabKeyNames> }> = ({
  totalData
}) => {
  console.log(totalData, 'totalData');
  // 图表类型
  const [chartType, setChartType] = useState('amount');

  // 选中的指标
  const [selectedMetrics, setSelectedMetrics] = useState({
    annualReturn: false,
    sharpeRatio: true,
    netValue: true,
    tradingFeatures: true
  });

  useEffect(() => {
    console.log('totalData updated:', totalData);
  }, [totalData]);

  // 全选状态
  const selectAll = useMemo(() => {
    const values = Object.values(selectedMetrics);
    return values.length > 0 && values.every(v => v);
  }, [selectedMetrics]);

  // 半选状态
  const isIndeterminate = useMemo(() => {
    const values = Object.values(selectedMetrics);
    const checkedCount = values.filter(v => v).length;
    return checkedCount > 0 && checkedCount < values.length;
  }, [selectedMetrics]);

  // 处理全选
  const handleSelectAll = (value: boolean) => {
    const newMetrics = { ...selectedMetrics };
    Object.keys(newMetrics).forEach(key => {
      newMetrics[key as keyof typeof selectedMetrics] = value;
    });
    setSelectedMetrics(newMetrics);
  };
  const handleSelectChange = (key: string, checked: boolean) => {
    setSelectedMetrics(prev => ({
      ...prev,
      [key]: checked
    }));
  };

  return (
    <>
      <ScrollArea className="w-full h-full scroll-area-block">
        <div className="p-4 bg-white rounded-lg pb-16">
          {/* AI智能诊断总结卡片 */}
          <Summary>
            <div className="flex">
              <span className="text-xs text-[#1F1F1F] text-left font-semibold whitespace-nowrap mr-1 leading-5">
                市场分析:
              </span>
              <span className="text-xs text-[#1F1F1F] text-left leading-5">
                {totalData.market_analysis}
              </span>
            </div>
            <div className="flex">
              <span className="text-xs text-[#1F1F1F] text-left font-semibold whitespace-nowrap mr-1 leading-5">
                建议:
              </span>
              <span className="text-xs text-[#1F1F1F] text-left leading-5">
                {totalData.suggestion}
              </span>
            </div>
          </Summary>
          {/* 指标选择区域 */}
          <MetricsSelector
            selectedMetrics={selectedMetrics}
            selectChange={handleSelectChange}
            totalData={totalData}
          />
          {/* 账户净值表现 */}
          <NetValueChart
            selectedMetrics={selectedMetrics}
            chartType={chartType}
            onUpdateChartType={setChartType}
            selectChange={handleSelectChange}
            totalData={totalData}
          />
          {/* 交易特征 */}
          <TradingFeatures
            selectedMetrics={selectedMetrics}
            selectChange={handleSelectChange}
            totalData={totalData}
          />
        </div>
      </ScrollArea>
      {/* 底部操作栏 */}
      <ActionBar
        selectAll={selectAll}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
      />
    </>
  );
};

export default OverviewTab;
